/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {Component, ViewEncapsulation, Inject, ChangeDetectionStrategy, Injectable, Output, EventEmitter} from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material';

/**
 * A component used to open as the default snack bar, matching material spec.
 * This should only be used internally by the snack bar service.
 */
@Component({
  moduleId: module.id,
  selector: 'multiline-snack-bar',
  templateUrl: 'multiline-snack-bar.component.html',
  styleUrls: ['multiline-snack-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'mat-simple-snackbar',
  }
})

@Injectable()
export class MultilineSnackBar {
  data: {messages: string[], action: string};

  //@Output() showDetails: EventEmitter<any> = new EventEmitter();

  constructor(
    public snackBarRef: MatSnackBarRef<MultilineSnackBar>,
    @Inject(MAT_SNACK_BAR_DATA) data: any) {
    this.data = data;
  }

  /** Performs the action on the snack bar. */
  action(): void {
    this.snackBarRef.dismiss();
  }

  /** If the action button should be shown. */
  get hasAction(): boolean {
    return !!this.data.action;
  }

  onShowDetailsClick(){
    //this.showDetails.emit(null);
    this.snackBarRef.dismissWithAction();
  }
}